import { useQuery } from "@tanstack/react-query";
import { CouplesPack } from "@/pages/couples-pack/types/couples-pack";
import { getCouplesPack } from "../services/get-couples-packs";

interface PaginatedCouplesPacks {
  couplesPacks: Array<CouplesPack>;
  lastPage: number;
  nextPage: number | null;
  currentPage: number;
}

export default function useCouplesPack(
  page: number = 0,
  search?: string,
  filter?: string,
  professional_id?: string,
) {
  const { data, isLoading, error, isFetching, isSuccess } =
    useQuery<PaginatedCouplesPacks>({
      queryKey: [
        "couples-packs",
        {
          page,
          search,
          filter,
          professional_id,
        },
      ],
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 30, // 30 minutes
      queryFn: () =>
        getCouplesPack({
          page,
          search,
          filter,
          professional_id
        }),
    });

  return { data, isLoading, error, isFetching, isSuccess };
}
